const tblJoint = {
  55: [8.0,20.00, 20.00],
  56: [8.0,21.00, 21.00],
  57: [9.0,22.00,22.00],
  58: [10.0, 23.00, 23.00],
  59: [11.5, 24.00, 24.00],
  60: [12.5, 25.00, 25.00],
  61: [14.0, 26.00, 26.20],
  62: [15.0, 27.00, 27.30],
  63: [16.0, 28.00, 28.00],
  64: [17.0, 29.00, 29.00],
  65: [18.0, 30.00, 30.00],
  66: [19.5, 31.00, 31.00],
  67: [21.0, 32.00, 32.00],
  68: [22.0, 33.00, 33.00],
  69: [23.0, 34.00, 34.00],
  70: [24.5, 35.00, 35.00],
  71: [26.0, 36.00, 36.00],
  72: [27.0, 37.00, 37.00],
  73: [28.0, 38.00, 38.00],
  74: [28.5, 39.00, 39.00],
  75: [29.0, 40.00, 40.00],
  76: [30.0, 41.00, 41.00],
  77: [30.5, 42.00, 42.00],
  78: [31.0, 43.00, 43.00],
  79: [32.0, 44.00, 44.00],
  80: [33.0, 45.00, 45.00],
  81: [34.0, 45.00, 45.00],
  82: [35.0, 45.00, 45.00],
  83: [36.0, 45.00, 45.00],
  84: [37.0, 45.00, 45.00],
  85: [38.0, 46.00, 46.00],
  86: [38.0, 46.00, 46.00],
  87: [38.0, 46.00, 46.00],
  88: [38.0, 46.00, 46.00],
  89: [38.0, 46.00, 46.00],
  90: [38.0, 46.00, 46.00]
};

const tblSingle = {
  55: [8.0,21.00, 21.00],
  56: [9.0,22.00,22.00],
  57: [10.0, 23.00, 23.00],
  58: [11.5, 24.00, 24.00],
  59: [12.5, 25.00, 25.00],
  60: [14.0, 26.00, 26.20],
  61: [15.0, 27.00, 27.30],
  62: [16.0, 28.00, 28.00],
  63: [17.0, 29.00, 29.00],
  64: [18.0, 30.00, 30.00],
  65: [19.5, 31.00, 31.00],
  66: [21.0, 32.00, 32.00],
  67: [22.0, 33.00, 33.00],
  68: [23.0, 34.00, 34.00],
  69: [24.5, 35.00, 35.00],
  70: [26.0, 36.00, 36.00],
  71: [27.0, 37.00, 37.00],
  72: [28.0, 38.00, 38.00],
  73: [28.5, 39.00, 39.00],
  74: [29.0, 40.00, 40.00],
  75: [30.0, 41.00, 41.00],
  76: [30.5, 42.00, 42.00],
  77: [31.0, 43.00, 43.00],
  78: [32.0, 44.00, 44.00],
  79: [33.0, 45.00, 45.00],
  80: [34.0, 46.00, 46.00],
  81: [35.0, 46.00, 46.00],
  82: [36.0, 46.00, 46.00],
  83: [37.0, 46.00, 46.00],
  84: [38.0, 46.00, 46.00],
  85: [38.0, 46.00, 46.00],
  86: [38.0, 46.00, 46.00],
  87: [38.0, 46.00, 46.00],
  88: [38.0, 46.00, 46.00],
  89: [38.0, 46.00, 46.00],
  90: [38.0, 46.00, 46.00]
};

const fallBack  = {
  55: [10.0, 12.0],
  56: [11.0, 12.0],
  57: [12.5, 12.5]
};
// const isValid = x => (typeof x !== 'undefined' && x !== null && !isNaN(x));

export const getLtvValue = ({ clientAge, isJoint, housePrice, ltvPlan }) => {
  const age = (clientAge > 90) ? 90 : clientAge;
  const tbl = (isJoint) ? tblJoint[age] : tblSingle[age];

  let fallback = null;

  if(age < 58)
  {
    fallback = fallBack[age]
  }

  let HealthyPreCalc = parseInt( housePrice * 0.01 * tbl[0], 10);
  let HealthPreCalcPer = tbl[0];

  if(HealthyPreCalc < 10000)
  {
    HealthyPreCalc = parseInt( housePrice * 0.01 * fallback[0], 10);
    HealthPreCalcPer = fallback[0];
  }

  if(HealthyPreCalc < 10000)
  {
    HealthyPreCalc = parseInt( housePrice * 0.01 * fallback[1], 10);
    HealthPreCalcPer = fallback[1];
  }

  const Healthy = HealthyPreCalc;
  const Mild = parseInt( housePrice * 0.01 * tbl[1], 10);
  const Moderate = parseInt( housePrice * 0.01 * tbl[2], 10);

  const result = { Healthy, Mild, Moderate };
  result.max = result[ ltvPlan || 'Moderate' ];
  result.diff = result.Moderate - result.Healthy;
  result.pct = { Healthy: HealthPreCalcPer, Mild: tbl[1], Moderate: tbl[2] };
  return result;
};



// WEBPACK FOOTER //
// ./src/services/LtvCalc.js